import React from "react";
import { useCasinoPage } from "../CasinoPageContext";
import { HTMLService } from "../services/html";

const AboutSection = () => {
  const { website } = useCasinoPage();

  const contentHtml = website?.homepageContent?.aboutSection.content || "";

  return (
    <section
      id="about-section"
      className="
        relative bg-gradient-to-b
        from-slate-950 via-slate-900 to-black
        text-white py-20 md:py-32
        overflow-hidden flex justify-center
      "
    >
      <div className="absolute inset-0 bg-black/30"></div>

      {/* Ambient glows */}
      <div className="pointer-events-none absolute -top-36 -left-40 h-72 w-72 bg-orange-500/10 blur-3xl rounded-full" />
      <div className="pointer-events-none absolute -bottom-40 -right-32 h-72 w-72 bg-blue-500/10 blur-3xl rounded-full" />

      <div className="relative z-10 max-w-7xl w-full px-6 sm:px-8 lg:px-12">
        {/* Section Title */}
        <div className="text-center mb-12 md:mb-16">
          <p
            className="
              inline-flex items-center justify-center px-3 py-1 mb-4
              text-[11px] md:text-xs font-semibold uppercase tracking-[0.25em]
              text-orange-300/80 bg-white/5 backdrop-blur-sm rounded-full
            "
          >
            About CasinoB8
          </p>

          <p className="mt-5 text-gray-300 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            How we combine SEO expertise, data-driven research, and a
            player-first mindset to build a smarter way to explore online
            casinos.
          </p>
        </div>

        {/* 
          ✅ SEO SAFE CONTENT RENDER
          - No artificial paragraph splitting
          - CMS controls structure
          - Tools see one coherent text block
        */}
        <div
          className="
            prose prose-invert max-w-none
            text-gray-200 leading-relaxed

            /* Desktop two-column purely via CSS */
            md:columns-2 md:gap-12

            /* Nice paragraph spacing */
            [&_p]:mb-4
            [&_h2]:mt-6 [&_h2]:mb-3
            [&_h3]:mt-5 [&_h3]:mb-2
          "
        >
          {HTMLService.toReact(contentHtml)}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
